module.exports = __webpack_public_path__ + "img/import.f86fb6eb.svg";